import { parse } from "graphql";

import type { TypedDocumentNode } from "@apollo/client";

type MagazineMediaPublicationStatusResult = {
	hotelApplicationStatus: {
		id: string;
		isMagazineMediaPublicationRequested?: boolean | null;
	};
};

type MagazineMediaPublicationStatusVariables = {
	hotelID: string;
};

/**
 * 掲載依頼済みかどうかだけを読む。
 * mutation と同じ理由で graphql タグを使わない（デプロイ前の codegen が未知のフィールドで失敗するため）。
 * フィールドがデプロイされたら HotelApplicationDataQuery に寄せてこのクエリは消す
 */
export const MAGAZINE_MEDIA_PUBLICATION_STATUS_QUERY: TypedDocumentNode<
	MagazineMediaPublicationStatusResult,
	MagazineMediaPublicationStatusVariables
> = parse(`
	query MagazineMediaPublicationStatus($hotelID: ID!) {
		hotelApplicationStatus(hotelID: $hotelID) {
			id
			isMagazineMediaPublicationRequested
		}
	}
`) as TypedDocumentNode<MagazineMediaPublicationStatusResult, MagazineMediaPublicationStatusVariables>;
